import styled from "styled-components";

export const OfferCardWrapper = styled.div`
  .offer_card_Wrap {
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(39, 44, 101, 0.3);
    border-radius: 20px;
    padding: 0px 30px 30px 30px;
    transition: all 0.4s ease-in-out;
    position: relative;
    z-index: 2;
    @media (max-width: 1199px) {
      padding: 0px 20px 20px 20px;
      border-radius: 15px;
    }
    &:hover {
      box-shadow: 25px 26px 84px rgba(255, 24, 24, 0.2);
      border-color: rgb(255, 255, 255);
      .cardArrowIcon {
        background: rgb(255, 24, 24);
        color: rgb(255, 255, 255);

        transform: rotate(45deg);
      }
    }
    .show_card_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 90px;
      height: 90px;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(191, 192, 209);
      box-shadow: 10px 5px 34px rgba(48, 128, 197, 0.1);
      border-radius: 50%;
      margin-top: -45px;
      @media (max-width: 1199px) {
        width: 70px;
        height: 70px;
        margin-top: -30px;
      }
    }
    h3{
      margin: 7px 0;
    }
    .cardArrowIcon {
      margin-top: 20px;
      width: 51px;
      height: 51px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgb(243, 243, 243);
      color: rgb(39, 44, 101);
      border-radius: 50px;
      transition: 0.4s ease-in-out;
      /* &:hover {
        background: rgb(255, 24, 24);
        color: rgb(255, 255, 255);
      } */
    }
  }
`;
